export const required = value => {
  if (typeof value === 'string') {
    // Don't accept only whitespace
    return value.trim() ? undefined : 'Required'
  }
  return value ? undefined : 'Required'
}

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,9}$/i.test(value)
    ? 'Invalid email address'
    : undefined

export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined

export const maxValue = max => value =>
  value && value > max ? `Must be less than $${max}` : undefined
